import React, { useEffect, useState } from "react";
import Helpers from "../Helper/Helpers";

const SocialMediaIcons = () => {
  const [socialLinks, setSocialLinks] = useState([]);
  useEffect(() => {
    FetchAllSocial();
  }, []);

  const FetchAllSocial = async () => {
    try {
      const res = await Helpers("/admin/social/get", "GET");
      if (res && res?.status) {
        setSocialLinks(res?.data?.reverse());
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
        gap: "20px",
        justifyContent: "center",
        padding: "0 10px",
        maxWidth: "1000px",
        margin: "0 auto",
      }}
    >
      {socialLinks?.map((social, index) => (
        <a
          key={index}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: "100%",
            height: "auto",
            aspectRatio: "250 / 429",
            borderRadius: "12px",
            overflow: "hidden",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
            transition: "transform 0.3s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.02)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <img
            src={social.image}
            alt={social.name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </a>
      ))}
    </div>
  );
};

export default SocialMediaIcons;
